import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';

@Component({
  selector: 'anihis-result-trio-dog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  templateUrl: './result-trio-dog.component.html',
  styleUrls: ['./result-trio-dog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultTrioDogComponent
  extends FormBaseComponent
  implements OnInit
{
  @Output() formChange = new EventEmitter<any>();

  override ngOnInit(): void {
    this.form = this.fb.group({
      cpv: [''],
      ccv: [''],
      giardia: [''],
      note: [''],
      veterinarianName: [''],
    });

    // Emit initial value and subsequent changes
    this.formChange.emit(this.form.value);
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );

    super.ngOnInit();
  }
}
